// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer___3Ulc-","angelImg":"angelImg___Zk54P","backBtn":"backBtn___1fiqd","nextBtn":"nextBtn___3klRH","disableBtn":"disableBtn___3YIk4"};